import { GHubThemeType } from './ghub-theme.type';

type ThemeStylesheetLoaderProps = {
  theme: GHubThemeType;
};

export const ThemeStylesheetLoader = ({ theme }: ThemeStylesheetLoaderProps) => {
  if (theme === 'glacier') import('./stylesheets/glacier.colors.scss');
  if (theme === 'af') import('./stylesheets/af.colors.scss');
  return null;
};
